"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDialogActions = exports.StyledDialogContent = exports.StyledDialogHeader = exports.StyledDialog = void 0;
const flora_react_1 = require("@grupoboticario/flora-react");
exports.StyledDialog = (0, flora_react_1.styled)('dialog', {
    border: 'none',
    borderRadius: '$medium',
    backgroundColor: '$light-light',
    padding: 0,
    width: '100%',
    maxWidth: '316px',
    borderLeft: '8px solid $actionNavigationStandardStatic',
});
exports.StyledDialogHeader = (0, flora_react_1.styled)('div', {
    padding: '$0 $3',
    borderBottom: '1px solid #F5F1EB',
});
exports.StyledDialogContent = (0, flora_react_1.styled)('div', {
    padding: '$3',
});
exports.StyledDialogActions = (0, flora_react_1.styled)(flora_react_1.Flex, {
    gap: '$4',
    padding: '$3',
    justifyContent: 'flex-end',
});
